// Created by 任泽阳 on 19/03/14. // 资产中心 合约账户页面
<template>
  <div class="page-coAccount main-second-bg">
    <!-- 开通合约弹框 -->
    <openFutures :isShow="openFuturesDialogShow" :close="closeDialog" />
    <div class="a-7-bd">
      <div class="exchangeAccount-title a-3-bd">
        <!-- 合约账户 -->
        <div class="text b-1-cl medium">{{ $t("futures.coAccount.coAccount") }}</div>
      </div>
      <div class="exchangeAccount-center">
        <c-table
          :cellHeight="55"
          :imgMap="imgMap"
          :colorMap="colorMap"
          :loading="tabelLoading"
          :lineNumber="tableData.length"
          @elementClick="tableClick"
          :columns="columns"
          :dataList="tableData"
        />
      </div>
    </div>

    <CommonTransfer ref="CommonTransfer" @success="transferSuccess"> </CommonTransfer>
  </div>
</template>

<script>
// 开通合约交易弹框
import openFutures from '@/components/modules/coTrade/component/openFutures.vue';
import { fixD, colorMap, imgMap } from '@/utils';
import CommonTransfer from '@/views/components/CommonTransfer.vue';

export default {
  components: {
    openFutures,
    CommonTransfer,
  },
  name: 'page-coAccount',
  data() {
    return {
      tabelInfoData: [], // 列表元素数据
      detailsData: {}, // 账户详情
      tabelLoading: true,
      imgMap,
      colorMap,
      transferSide: '1',
      transferValue: '',
      dialogConfirmLoading: false,
      // openContract:true,
      // transStatus:0,
      symbol: null,
      // 开通合约交易弹框
      openFuturesDialogShow: false,
    };
  },
  filters: {
    fixDFn(v, that) {
      return fixD(v, that.detailsData.showPrecision);
    },
  },
  watch: {
    // 监听 用户配置信息
    openContract(val) {
      if (!val) {
        this.openFuturesDialogShow = true;
      }
    },
  },
  computed: {
    // 是否登录
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    // 是否开通合约
    openContract() {
      if (this.$store.state.future) {
        return this.$store.state.future.openContract;
      }
      return true;
    },
    // 是否被冻结
    transStatus() {
      if (this.$store.state.future) {
        return this.$store.state.future.transStatus;
      }
      return true;
    },
    // 币种信息
    marginCoinInfor() {
      if (this.$store.state.future.marginCoinInfor) {
        return this.$store.state.future.marginCoinInfor;
      }
      return {};
    },
    // 合约列表
    contractList() {
      if (this.$store.state.future.contractList) {
        return this.$store.state.future.contractList;
      }
      return [];
    },
    userInfo() {
      if (this.$store.state.baseData.userInfo) {
        return this.$store.state.baseData.userInfo;
      }
      return {};
    },
    // 表格数据
    tableData() {
      const arr = [];
      this.tabelInfoData.forEach((item) => {
        if (this.marginCoinInfor && this.marginCoinInfor[item.symbol]) {
          const precision = this.marginCoinInfor[item.symbol].marginCoinPrecision;
          arr.push({
            id: JSON.stringify(item),
            data: [
              item.symbol, // 币种
              fixD(item.canUseAmount, precision), // 可用s
              fixD(item.totalAmount, precision), // 总资产
              fixD(item.totalMargin, precision), // 全仓保证金
              fixD(item.isolateMargin, precision), // 逐仓保证金
              fixD(item.lockAmount, precision), // 冻结保证金
              // fixD(item.realizedAmount, precision), // 已实现盈亏
              // fixD(item.unRealizedAmount, precision), // 未实现盈亏
              [
                {
                  type: this.transStatus ? 'button' : 'label',
                  text: this.$t('futures.coAccount.transfer'), // 划转
                  eventType: 'clickDialog',
                  classes: [this.transStatus ? '' : 'tableNownStyle tableTithDraw b-2-cl', 'margin-left-10'],
                },
              ],
            ],
          });
        }
      });
      return arr;
    },
    // 表格title
    columns() {
      return [
        { title: this.$t('futures.coAccount.coin'), width: '15%' }, // 币种
        { title: this.$t('futures.coAccount.canUser'), width: '15%' }, // 可用
        { title: this.$t('futures.coAccount.allBalance'), width: '15%' }, // 总资产
        { title: this.$t('futures.coAccount.allMargin'), width: '15%' }, // 全仓保证金
        { title: this.$t('futures.coAccount.subMargin'), width: '15%' }, // 逐仓保证金
        { title: this.$t('futures.coAccount.lockMargin'), width: '15%' }, // 冻结保证金
        // { title: '已实现盈亏', width: '10%' }, // 已实现盈亏
        // { title: '未实现盈亏', width: '10%' }, // 未实现盈亏s
        { title: this.$t('futures.coAccount.opera'), width: '10%' }, // 操作
      ];
    },
    // market 接口
    market() {
      return this.$store.state.baseData.market;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // 请求合约PublicInfo
      this.$store.dispatch('getFutorePublicInfo');
      // 请求用户配置
      this.$store.dispatch('getUserConfig');
      if (!this.openContract) {
        this.openFuturesDialogShow = true;
      }
      this.getDetailData();
    },
    getDetailData() {
      this.axios({
        url: 'position/get_assets_list',
        hostType: 'co',
        params: {
          onlyAccount: 1,
        },
      }).then((data) => {
        this.tabelLoading = false;
        if (data.code.toString() === '0') {
          if (data.data.accountList.length) {
            this.tabelInfoData = data.data.accountList;
          }
        }
      }).catch(() => {
        this.tabelLoading = false;
      });
    },
    tableClick(type, data) {
      if (type === 'clickDialog') {
        this.symbol = JSON.parse(data).symbol;
        this.$refs.CommonTransfer.show(this.symbol, true, 'future');
      }
    },
    // 开通合约交易
    submit() {
      this.openFuturesDialogShow = false;
      this.getDetailData();
    },
    // 关闭弹窗
    closeDialog(data) {
      if (data) {
        this.getDetailData();
      }
      // 关闭开通合约交易弹框
      this.openFuturesDialogShow = false;
    },
    transferSuccess() {
      this.getDetailData();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-coAccount {
  min-height: 800px;
  border-radius: 6px;

  .openClass {
    text-align: center;
    padding-top: 250px;
  }
  .tableNownStyle {
    display: inline-block;
    height: 26px;
    line-height: 26px;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
    cursor: no-drop;
  }
  .tableTithDraw {
    margin-left: 10px;
  }
  position: relative;
  width: 100%;
  height: 100%;
  .switchWrap {
    display: inline-block;
  }
  .coAccount-header {
    width: 100%;
    height: 200px;
    padding: 40px 30px 20px 30px;
    box-sizing: border-box;
    .options {
      display: inline-block;
      margin-top: 30px;
      cursor: pointer;
    }
    .quota {
      float: left;
      .title {
        font-size: 12px;
      }
      .number {
        height: 32px;
        font-size: 32px;
        margin: 8px 0;
      }
      .Company {
        font-size: 14px;
        margin-left: 8px;
      }
      .Legal {
        font-size: 12px;
      }
    }
    .cohead-list {
      float: left;
      margin-left: 60px;
      padding-left: 20px;
      border-left-width: 1px;
      border-left-style: solid;
      li {
        margin-top: 20px;
        &:first-child {
          margin: 0;
        }
      }
      .key {
        font-size: 12px;
      }
      .value {
        font-size: 16px;
        margin-top: 4px;
      }
    }
  }
  .exchangeAccount-body {
    border-top-width: 10px;
    border-top-style: solid;
  }
  .exchangeAccount-title {
    height: 55px;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    padding: 0 20px;
    vertical-align: middle;
    .text {
      float: left;
      font-size: 14px;
      display: inline-block;
      line-height: 55px;
    }
    .client {
      float: right;
      line-height: 55px;
      font-size: 12px;
      .client-icon {
        vertical-align: middle;
      }
      .client-text {
        vertical-align: middle;
      }
    }
  }
  .exchangeAccount-center {
    width: 100%;
    box-sizing: border-box;
    .table-head,
    .table-body-bar {
      padding: 0 !important;
    }
  }
  .transfer-box {
    padding-top: 10px;
    padding-bottom: 16px;
    .transfer-content {
      width: 400px;
      height: 70px;
      margin-bottom: 23px;
      user-select: none;
      li {
        float: left;
      }
      .transfer-page {
        width: 160px;
        padding-left: 15px;
        height: 70px;
      }
      .transfer-page-side {
        font-size: 12px;
        line-height: 16px;
        margin-top: 13px;
      }
      .transfer-page-name {
        margin-top: 5px;
        font-size: 14px;
      }
      .transfer-icon {
        width: 50px;
        height: 70px;
        line-height: 85px;
        text-align: center;
        .icon {
          cursor: pointer;
        }
      }
    }
  }
  .coAccount-header-bg {
    background-image: linear-gradient(-269deg, #0491ce 0%, #00aeb6 100%);
  }
  .coAccount-header {
    background-position: right bottom !important;
    background-repeat: no-repeat !important;
  }
}
</style>
